import { render, staticRenderFns } from "./ColoredWidget.vue?vue&type=template&id=238a1c67&scoped=true"
import script from "./ColoredWidget.vue?vue&type=script&lang=ts"
export * from "./ColoredWidget.vue?vue&type=script&lang=ts"
import style0 from "./ColoredWidget.vue?vue&type=style&index=0&id=238a1c67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a1c67",
  null
  
)

export default component.exports